// extracted by mini-css-extract-plugin
module.exports = {"community-page":"Community_community-page__CmLpm"};